export const QUERY_KEYS = {
	playerStatistics: "playerStatistics",
	factions: "factions",
	factionStatistics: "factionStatistics",
	gameTypes: "gameTypes",
	categories: "categories",
	mechanics: "mechanics",
	people: "people",
	players: "players",
	player: "player",
	statistics: "statistics",
	sessions: "sessions",
	counts: "counts",
	loans: "loans",
	compare: "compare",
	settings: "settings",
	games: "games",
	game: "game",
	bgg: "bgg",
	expansions: "expansions",
	manuals: "manuals",
	locations: "locations",
	dashboard: "dashboard",
	charts: "charts",
	languages: "languages",
	environment: "environment",
	shortlist: "shortlist",
	badges: "badges",
	versionInfo: "versionInfo",
	shames: "shames",
	gameNights: "gameNights",
	gameNightStatistics: "gameNightStatistics",
	profile: "profile",
	users: "users",
};
